import { useTheToast } from '#imports'

import { cartAPI } from '@backmarket/http-api'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { openModal } from '@ds/components/ModalBase'

import { MODAL_NAMES as SWAP_MODAL_NAMES } from '~/scopes/buyback/constants'
import {
  SWAP_ERROR,
  SWAP_NONE,
} from '~/scopes/buyback/swap/components/SwapBlock/constants'

import { MODAL_NAMES } from '../constants'

export const useAddToCart = () => {
  const { openErrorToast } = useTheToast()
  const { trackAddToCart, trackErrors } = useTracking()

  const addToCart = async ({
    listingId,
    tracking,
    swapStatus,
  }: {
    listingId: number
    tracking: object
    swapStatus: string
  }) => {
    trackAddToCart({
      ...tracking,
      quantity: 1,
    })

    try {
      await $httpFetch(cartAPI.addToCart, {
        body: {
          listing_id: listingId,
          // TODO [] add tracking infos when the customer comes from a search
          searchRelatedQuery: {
            id: null,
            index: null,
          },
        },
      })

      if (swapStatus === SWAP_NONE || swapStatus === SWAP_ERROR) {
        openModal(SWAP_MODAL_NAMES.SWAP_ATC)
      } else {
        openModal(MODAL_NAMES.ADD_TO_CART)
      }
    } catch (error) {
      trackErrors({
        zone: 'add_to_cart',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        message: (error as any)?.payload?.detail ?? 'unknown_error',
      })

      openErrorToast()
    }
  }

  return {
    addToCart,
  }
}
